import { ModalAction, ModalState } from '../model/modal.model';

export const modalReducer = (state: ModalState, action: ModalAction): ModalState => {
  switch (action.type) {
    case 'OPEN':
      return { ...state, [action.payload]: true };
    case 'CLOSE':
      return { ...state, [action.payload]: false };
    case 'CLOSE_ALL':
      return {};
    default:
      return state;
  }
};
